import { Stack, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { IconTooltip } from 'common/ui';

export enum OverlappingCampaignAction {
  WAIT = 'wait',
  SWITCH = 'switch'
}

export const OVERLAPPING_CAMPAIGNS_LABEL =
  'If invited candidates are in other campaigns';

const infoIconSx = { fontSize: 24, color: 'primary.main' } as const;

const OptionLabel = ({
  label,
  subLabel,
  tooltip
}: {
  label: string;
  subLabel: string;
  tooltip?: React.ReactNode;
}) => (
  <Stack direction="row" alignItems="flex-start" spacing={1}>
    <Stack spacing={0.5}>
      <Typography fontWeight="bold">{label}</Typography>
      <Typography>{subLabel}</Typography>
    </Stack>
    {tooltip && (
      <IconTooltip title={tooltip}>
        <InfoOutlined sx={infoIconSx} />
      </IconTooltip>
    )}
  </Stack>
);

export const overlappingCampaignsRadioOptions = [
  {
    label: (
      <OptionLabel
        label="Wait for current campaigns to complete"
        subLabel="Send this one only after they've finished their active conversations."
      />
    ),
    value: OverlappingCampaignAction.WAIT,
    alignItems: 'flex-start' as const
  },
  {
    label: (
      <OptionLabel
        label="Switch to this campaign now"
        subLabel="Move candidates immediately (except those in active conversations)."
        tooltip={
          <Typography
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              maxWidth: 200,
              textAlign: 'center'
            }}
          >
            Candidates not in active conversations will move to this one
            instead.{' '}
            <b>Their status will update to show they've transitioned</b>, and
            this will not affect anyone you are already messaging.
          </Typography>
        }
      />
    ),
    value: OverlappingCampaignAction.SWITCH,
    alignItems: 'flex-start' as const
  }
];
